import { ReactNode, useState, useMemo, useEffect } from 'react';
import { Provider } from 'react-redux';
import {BrowserRouter, useLocation} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import {CssBaseline} from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';  // Переименовываем, чтобы не конфликтовало
import { persistor, store } from 'app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { EvmChains } from 'shared/types';
import { ProgressCloseButton } from 'shared/ui/components';
import {useWeb3Auth, Web3AuthProvider} from './Web3AuthProvider';
import 'react-toastify/dist/ReactToastify.css';
export { RouteManager } from './router';
import { ThemeProvider, useTheme } from './ThemeContext';
import {createThemeColors} from "../../shared/config";


interface GlobalProviderProps {
  children?: ReactNode;
}

export const GlobalProvider = ({ children }: GlobalProviderProps) => {
  const { theme } = useTheme();
  return (
        <MuiThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <Web3AuthProvider web3AuthNetwork="mainnet" chain={EvmChains.Polygon}>
                <BrowserRouter>
                  <CssBaseline/>
                  <ToastContainer
                      autoClose={4000}
                      hideProgressBar
                      style={{display: 'none'}}
                      position="bottom-right"
                      closeButton={<ProgressCloseButton/>}
                  />
                  {children}
                </BrowserRouter>
              </Web3AuthProvider>
            </PersistGate>
          </Provider>
        </MuiThemeProvider>
  );
}
